
import { MODULE } from "@/config/modules";
import { AuthService, DossierConfigService, UserConfigService } from "@/services";
import { isStringEmail } from "@/utils/strings";
import AppMissingModuleModal from "@/components/common/MissingModuleModal.vue";
import Vue from "vue";
import { Permissions } from "@/models/user-configs/permissions";
import AppPurchaseInboxReaderSettingsEditMailboxAlias from "./PurchaseInboxreaderSettingsEditMailboxAlias.vue";
import { InboxreaderService } from "@/services/inboxreader-service";

export default Vue.extend({
	data(){
		return {
			input: "",
			settings: DossierConfigService.getPurchaseConfig(),
			inputFocussed: false,
			mailboxAlias: "",
			mailboxAliasEditOpen: false
		};
	},
	computed: {
		inputValid():boolean{
			let input = this.input.toLowerCase();
			if (input.trim() == "") return false;
			let i = this.settings.PurchasesFromInboxreaderAllowedFroms.findIndex(i=>i.toLowerCase().trim() == input);
			if (i != -1) return false;
			if (!isStringEmail(this.input)) return false;
			return true;
		},
		targetEmail():string{
			if (this.mailboxAlias) {
				return `${this.mailboxAlias}@winfakt.app`;
			}
			return `dossier_${AuthService.wfDossier.id}@winfakt.app`;
		},
		moduleId():number{
			return MODULE.INKOMENDE_AANKOPEN_UIT_MAILBOX;
		},
		hasModule():boolean {
			return AuthService.hasModule(this.moduleId);
		},
		canChangeAlias():boolean {
			return UserConfigService.hasCurrentUserPermission((permissions:Permissions):boolean=>{
				return permissions.IsAdmin;
			});
		}
	},
	methods: {
		async deleteItem(i:number){
			let message = this.$ct("are-you-sure-you-want-to-dewhitelist-mail", {text: this.settings.PurchasesFromInboxreaderAllowedFroms[i]});
			let confirm = await this.$confirmBuilder().setWarningTitle().setMessage(message).show();
			if (!confirm) return;
			this.settings.PurchasesFromInboxreaderAllowedFroms.splice(i, 1);
			await this.setSettings();
		},
		async addItem(){
			if (!this.inputValid) return;
			this.settings.PurchasesFromInboxreaderAllowedFroms.push(this.input.trim().toLowerCase());
			this.input = "";
			await this.setSettings();
		},
		setEnabled(val:boolean){
			this.settings.PurchasesFromInboxreaderEnabled = val;
			this.setSettings();
		},
		async setSettings(){
			this.settings = await DossierConfigService.setPurchaseConfig(this.settings);
		},
		async onAliasEditClosed(){
			this.mailboxAliasEditOpen = false;
			this.mailboxAlias = await InboxreaderService.getInboxReaderAlias();
		}
	},
	async created(){
		this.mailboxAlias = await InboxreaderService.getInboxReaderAlias();
	},
	components: {
		AppMissingModuleModal,
		AppPurchaseInboxReaderSettingsEditMailboxAlias
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
